import React from 'react';
import { Search as SearchIcon } from '@mui/icons-material';
import { T, fontBody, selectStyle } from './tokens';

export default function TabBar({ tabs, active, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 4, borderBottom: `1px solid ${T.line}`, marginBottom: 20 }}>
      {tabs.map((t) => {
        const Icon = t.icon;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            style={{
              display: 'flex', alignItems: 'center', gap: 6, border: 'none', background: 'transparent',
              padding: '10px 4px', marginRight: 22, fontFamily: fontBody, fontSize: 14, fontWeight: 600,
              color: active === t.id ? T.ink : T.slateLight,
              borderBottom: active === t.id ? `2px solid ${T.ink}` : '2px solid transparent',
              marginBottom: -1, cursor: 'pointer',
            }}
          >
            <Icon sx={{ fontSize: 14 }} /> {t.label}
          </button>
        );
      })}
    </div>
  );
}

export function FilterBar({ filter, onFilterChange, search, onSearchChange }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, gap: 12, flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', gap: 8 }}>
        {['all', 'active', 'paused'].map((f) => (
          <button
            key={f}
            type="button"
            onClick={() => onFilterChange(f)}
            style={{
              fontFamily: fontBody, fontSize: 12.5, fontWeight: 600, textTransform: 'capitalize',
              padding: '6px 14px', borderRadius: 8, border: `1px solid ${filter === f ? T.ink : T.line}`,
              background: filter === f ? T.ink : 'transparent', color: filter === f ? '#fff' : T.slate, cursor: 'pointer',
            }}
          >
            {f}
          </button>
        ))}
      </div>
      <div style={{ position: 'relative', minWidth: 220 }}>
        <SearchIcon sx={{ fontSize: 16, color: T.slateLight, position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)' }} />
        <input
          type="search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search automations"
          style={{
            ...selectStyle,
            paddingLeft: 34,
            width: 220,
            fontSize: 13,
          }}
        />
      </div>
    </div>
  );
}
